module.exports = __webpack_public_path__ + "img/upload-event-notice.f92ca434.png";